// UNSAVED WRITING NEVER SIMPLY DISAPPEARS. A small draft store for the essay / structure editors: what the student has typed but not yet
// committed (Return or Save), keyed by unit id ("thesis" for the thesis, "new" / "new:<region>" for a paragraph not yet added), kept across
// record refreshes and view switches (module memory mirrored to sessionStorage). NOT a second text authority: a draft reaches the record
// ONLY through the existing save call (Return, Save, a canvas click, or the commit before a TWS action), and only when it changed.
const KEY = "tws_writing_drafts";
let mem = null;

const load = () => {
  if (mem) return mem;
  try { mem = JSON.parse(sessionStorage.getItem(KEY) || "{}") || {}; } catch { mem = {}; }
  return mem;
};
const persist = () => { try { sessionStorage.setItem(KEY, JSON.stringify(load())); } catch { /* memory only */ } };

export const draftKey = (scope, id) => `${scope || ""}:${id}`;
export const getDraft = (scope, id) => load()[draftKey(scope, id)] || null;
export const setDraft = (scope, id, text, opened) => { load()[draftKey(scope, id)] = { text: text || "", opened: opened || "" }; persist(); };
export const clearDraft = (scope, id) => { delete load()[draftKey(scope, id)]; persist(); };
// "meaningfully changed": non-empty and different from the text the editor opened with (its persisted value)
export const draftChanged = (d) => !!d && (d.text || "").trim() !== "" && (d.text || "").trim() !== (d.opened || "").trim();
export const unsavedDrafts = (scope) => {
  const p = `${scope || ""}:`;
  return Object.entries(load()).filter(([k, d]) => k.startsWith(p) && draftChanged(d)).map(([k, d]) => ({ id: k.slice(p.length), text: d.text.trim(), opened: d.opened }));
};
export const resetDrafts = () => { mem = {}; persist(); };
